

































































































import { Vue, Component } from 'vue-property-decorator';
import LifecycleModule from '@/store/modules/lifecycle';
import UIModule from '@/store/modules/ui';
import UserModule from '@/store/modules/user';
import UnitsUtil from '@/util/UnitUtil';
import NotificationModule from '@/store/modules/notification';
import FlagUtil from '@/util/FlagUtil';
import { FWAccessControl } from '../util/AccessControlUtil';
import UserUtil from '../util/UserUtil';

let unitIdURL: string = '';
let partnerUsers: any[] = [];
let unitUsers: any[] = [];
let partnersLoaded: boolean = false;
let unitsLoaded: boolean = false;
let marketList: any[] = [];
let partnersRequestedFor: string | null = null;
let unitsRequestedFor: string | null = null;
let unitIdRequestedFor: string | null = null;

@Component({
  components: {},
})
export default class Navigation extends Vue {
  private showSidebar: boolean = false;

  private links = [
    {
      activeIcon: 'home.svg',
      inactiveIcon: 'home-outline.svg',
      title: 'Home',
      route: {
        name: 'home',
      },
    },
    {
      activeIcon: 'store.svg',
      inactiveIcon: 'store-outline.svg',
      title: 'Restaurants',
      route: {
        name: 'partners',
      },
      customRoute() {
        if (UserModule.currentRole === 'partner_owner') {
          const ownerId = UserModule.currentUser
            ? (UserModule.currentUser.id as string) : '';
          if (partnersRequestedFor !== ownerId) {
            partnersRequestedFor = ownerId;
            partnerUsers = [];
            partnersLoaded = false;
            const partner = UnitsUtil.getPartnerList().then((resp) => {
              if (partnersRequestedFor === ownerId) {
                partnerUsers = resp;
                partnersLoaded = true;
              }
            }).catch(() => {
              if (partnersRequestedFor === ownerId) {
                partnersRequestedFor = null;
              }
            });
          }
          if (partnerUsers.length === 0 && partnersLoaded === true) {
            return {
              name: 'notfound',
            };
          }
          if (partnerUsers.length === 1 && partnersLoaded === true) {
            return `/partners/${UserModule.currentPartner!.id}/details`;
          }
          if (partnerUsers.length > 1 && partnersLoaded === true) {
            return {
              name: 'partners',
            };
          }
        }
        return {
          name: 'partners',
        };
      },
      ac: {
        resource: 'page-partners',
      },
    },
    {
      activeIcon: 'configuration.svg',
      inactiveIcon: 'configuration-outline.svg',
      title: 'Configuration',
      route: {
        name: 'configuration',
      },
      ac: {
        resource: 'page-configuration',
      },
    },
    {
      activeIcon: 'user.svg',
      inactiveIcon: 'user-outline.svg',
      title: 'Users',
      route: {
        name: 'users',
      },
      ac: {
        resource: 'page-users',
      },
    },
    {
      activeIcon: 'units.svg',
      inactiveIcon: 'units-outline.svg',
      title: 'Units',
      route: {
        name: 'units',
      },
      customRoute() {
        if (
          UserModule.currentUser
          && UserModule.currentRole === 'unit_manager'
        ) {
          if (unitsRequestedFor !== UserModule.currentUser.id) {
            const userId = UserModule.currentUser.id as string;
            unitsRequestedFor = userId;
            unitUsers = [];
            unitsLoaded = false;
            unitIdURL = '';
            unitIdRequestedFor = null;
            const units = UnitsUtil.getMappedUnitList().then((resp) => {
              if (unitsRequestedFor === userId) {
                unitUsers = resp;
                unitsLoaded = true;
              }
            }).catch(() => {
              if (unitsRequestedFor === userId) {
                unitsRequestedFor = null;
              }
            });
          }
          if (unitUsers.length === 0 && unitsLoaded === true) {
            return {
              name: 'unit_not_found',
            };
          }
          if (unitUsers.length === 1 && unitsLoaded === true) {
            if (unitIdRequestedFor !== UserModule.currentUser.id) {
              const userId = UserModule.currentUser.id as string;
              unitIdRequestedFor = userId;
              const data = UnitsUtil.getMappedUnitId(
                userId,
              )
                // eslint-disable-next-line
                .then((resp) => {
                  if (unitIdRequestedFor === userId) {
                    unitIdURL = `/units/schedule-settings/${resp}`;
                  }
                }).catch(() => {
                  if (unitIdRequestedFor === userId) {
                    unitIdRequestedFor = null;
                  }
                });
            }
            return unitIdURL;
          }
          if (unitUsers.length > 1 && unitsLoaded === true) {
            return {
              name: 'units',
            };
          }
        }
        if (
          UserModule.currentUser
          && UserModule.currentRole === 'partner_owner'
        ) {
          if (unitsRequestedFor !== UserModule.currentUser.id) {
            const userId = UserModule.currentUser.id as string;
            unitsRequestedFor = userId;
            unitUsers = [];
            unitsLoaded = false;
            unitIdURL = '';
            unitIdRequestedFor = null;
            const units = UnitsUtil.getMappedUnitList().then((resp) => {
              if (unitsRequestedFor === userId) {
                unitUsers = resp;
                unitsLoaded = true;
              }
            }).catch(() => {
              if (unitsRequestedFor === userId) {
                unitsRequestedFor = null;
              }
            });
          }
          if (unitUsers.length === 0 && unitsLoaded === true) {
            return {
              name: 'unit_not_found',
            };
          }
          if (unitUsers.length === 1 && unitsLoaded === true) {
            if (unitIdRequestedFor !== UserModule.currentUser.id) {
              const userId = UserModule.currentUser.id as string;
              unitIdRequestedFor = userId;
              const data = UnitsUtil.getMappedUnitIdRestaurant()
                // eslint-disable-next-line
                .then((resp) => {
                  if (unitIdRequestedFor === userId) {
                    unitIdURL = `/units/schedule-settings/${resp}`;
                  }
                }).catch(() => {
                  if (unitIdRequestedFor === userId) {
                    unitIdRequestedFor = null;
                  }
                });
            }
            return unitIdURL;
          }
          if (unitUsers.length > 1 && unitsLoaded === true) {
            return {
              name: 'units',
            };
          }
        }
        return {
          name: 'units',
        };
      },
      ac: {
        resource: 'page-units',
      },
    },
    {
      flag: 'scheduler',
      customIf: () => {
        // const disabledIds = new Set<string>(FlagUtil.getFlags().market.scheduler_disabled);
        const enabledIds = new Set<string>(
          FlagUtil.getFlags().market.scheduler_enabled,
        );
        // const marketLists = UnitsUtil.getMarketList()
        //   .then(resp => {
        //     this.marketList = resp;
        //   })
        return (
          marketList.filter((e: any) => enabledIds.has(e.id as string)).length
          > 0
        );
      },
      activeIcon: 'schedule.svg',
      inactiveIcon: 'schedule_outline.svg',
      title: 'Calendar',
      route: {
        name: 'scheduler',
      },
    },
    {
      activeIcon: 'store.svg',
      inactiveIcon: 'store-outline.svg',
      title: 'Restaurants',
      route: {
        name: 'unit-restaurants',
      },
      ac: {
        resource: 'page-units-restaurant',
      },
    },
    {
      activeIcon: 'statistic.svg',
      inactiveIcon: 'statistic-outline.svg',
      title: 'Statistics',
      route: {
        name: 'market-stats',
      },
      customRoute() {
        if (UserModule.currentRole === 'partner_owner') {
          return {
            name: 'scheduler-statistics',
          };
        }
        return {
          name: 'market-stats',
        };
      },
      ac: {
        resource: 'page-statistics',
      },
    },
  ];

  private right = null;

  private hover = false;

  get drawer() {
    if (this.$vuetify.breakpoint.width > 800) {
      return true;
    }
    return UIModule.drawer;
  }

  set drawer(v) {
    UIModule.SET_DRAWER(v);
  }

  get pane() {
    return UIModule.pane;
  }

  set pane(v) {
    UIModule.SET_PANE(v);
  }

  togglePane() {
    this.pane = !this.pane;
  }

  get opacity() {
    if (this.hover) {
      return { opacity: 100, transition: 'opacity 0.2s ease-in-out' };
    }
    return { opacity: 0, transition: 'opacity 0.2s ease-in-out' };
  }

  get userInitials() {
    const user = UserModule.currentUser;
    if (user && user.name && user.name.first && user.name.last) {
      return user.name.first[0] + user.name.last[0];
    }
    return '';
  }

  get userName() {
    const user = UserModule.currentUser;
    if (user && user.name && user.name.first && user.name.last) {
      return `${user.name.first} ${user.name.last}`;
    }
    return '';
  }

  get role() {
    return UserUtil.getFormatedRole(UserModule.currentRole || '');
  }

  get expandOnHover() {
    return this.$vuetify.breakpoint.width > 800;
  }

  get displayLogout() {
    return this.hover;
  }

  get version() {
    return ` v ${process.env.VERSION}`;
  }

  public mounted() {
    this.getMarketUserList();
  }

  public async getMarketUserList() {
    marketList = await UnitsUtil.getMarketList();
    this.showSidebar = true;
  }

  getIcon(item: any, currentRoute: string) {
    const {
      activeIcon,
      inactiveIcon,
      route: { name },
    } = item;
    // eslint-disable-next-line
    if (currentRoute.includes(item.route.name)) return require(`@/assets/${activeIcon}`);
    // eslint-disable-next-line
    return require(`@/assets/${inactiveIcon}`);
  }

  private logout() {
    LifecycleModule.terminate();
    this.$router.push('/login');
  }

  checkAC(ac?: { resource: string; attribute: string }): boolean {
    if (ac) {
      return FWAccessControl.hasRead(ac.resource, ac.attribute);
    }
    return true;
  }

  get notificationCount() {
    if (NotificationModule.unreadCount > 9) {
      return '9+';
    }
    return NotificationModule.unreadCount;
  }

  checkFlag(flag?: string) {
    if (!flag) return true;
    return FlagUtil.hasFeature(flag);
  }

  checkCustomIf(link: any) {
    if (link.customIf) {
      return link.customIf();
    }

    return true;
  }
}
